import React, { Component } from 'react';
import Text from '@bit/knotchinc.web-react-components.text';
// import Box from '@bit/knotchinc.web-react-components.box';
import RoundedModal from 'components/Global/RoundedModal/RoundedModal.jsx';
import { connect } from 'react-redux';
import { PageBody } from '@bit/knotchinc.web-react-components.page';
import EntityPicker from 'components/Global/EntityPicker/EntityPicker.jsx';
import FetchCacheToggle from './FetchCacheToggle.jsx';
import { SettingsContainer, SettingsButton, AccountIcon } from './styled.js';
import { PROFILE_VIEW_MOUNTED, selectUserEntity, fetchSettingsBrands, fetchSettingsPublishers } from './actions.js';

export class ProfileMgmtView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEntityModal: false,
    };
  }

  componentDidMount() {
    this.props.profileMounted();
  }

  render() {
    const {
      Account: {
        userEntity,
        // data: { email },
        isKnotchAdmin,
      },
      getBrands,
      getPublishers,
      submit,
    } = this.props;
    const { userEntityModal } = this.state;
    const closeModal = () => this.setState({ userEntityModal: false });

    return (
      <PageBody>
        <RoundedModal close={closeModal} isOpen={userEntityModal} title="Select a brand or a publisher">
          <EntityPicker
            brandFetch={getBrands}
            publisherFetch={getPublishers}
            title="Select a brand or a publisher."
            submit={entity => { submit(entity); closeModal(); }}
          />
        </RoundedModal>
        <SettingsContainer borderRight width="100%">
          <AccountIcon url={userEntity ? userEntity.logo_url : null} />
          {userEntity && <Text color="palette.5" mb="22px">{userEntity.name}</Text>}
          {isKnotchAdmin && <SettingsButton centered width="84px" onClick={() => this.setState({ userEntityModal: true })}>CHANGE</SettingsButton>}
          {isKnotchAdmin && <FetchCacheToggle />}
        </SettingsContainer>
        {/* <SettingsContainer width="65%">
          <Box m="54px auto">
            <Box display="inline-block" width="40%" m="0 5%">
              <SettingsInput />
              <SettingsLabel>FIRST NAME</SettingsLabel>
            </Box>
            <Box display="inline-block" width="40%" m="0 5%">
              <SettingsInput />
              <SettingsLabel>LAST NAME</SettingsLabel>
            </Box>
          </Box>
          <Box width="90%" m="54px auto">
            <SettingsInput placeholder={email} />
            <SettingsLabel>EMAIL</SettingsLabel>
          </Box>
          <Box m="54px auto">
            <Box display="inline-block" width="40%" m="0 5%">
              <SettingsInput placeholder={userEntity ? userEntity.name : ''} />
              <SettingsLabel>Company</SettingsLabel>
            </Box>
            <Box display="inline-block" width="40%" m="0 5%">
              <SettingsInput />
              <SettingsLabel>Title</SettingsLabel>
            </Box>
          </Box>
          {isKnotchAdmin && <SettingsButton>EDIT</SettingsButton>}
        </SettingsContainer> */}
      </PageBody>);
  }
}


const mapStateToProps = ({
  Account,
  BrandsList,
  PublishersList,
}) => ({
  Account,
  brands: BrandsList.brandsList,
  publishers: PublishersList.publishersList,
});

const mapDispatchToProps = dispatch => ({
  getBrands: (clear) => dispatch(fetchSettingsBrands(clear)),
  getPublishers: (clear) => dispatch(fetchSettingsPublishers(clear)),
  profileMounted: () => dispatch({ type: PROFILE_VIEW_MOUNTED }),
  submit: (entity) => dispatch(selectUserEntity(entity)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ProfileMgmtView);
